import { MerchantPublicConfigurationModel } from './merchant-public-configuration.model';

//const apiUrl = '/api/configuration';

export const configurationClient = {
  getPublic(): Promise<MerchantPublicConfigurationModel> {
    return Promise.resolve({});
  },
};
